import { useOutletContext } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { Process } from "../components/Process";
import { Modernize } from "../components/Modernize";
import { Mail } from "../components/Mail";
import { Local } from "../components/Local";
import { AIStatement } from "../components/AIStatement";
import { Scenarios } from "../components/Scenarios";
import { ContactCTA } from "../components/ContactCTA";

type Ctx = { openModal: () => void };

export function HomePage() {
  const { openModal } = useOutletContext<Ctx>();
  return (
    <>
      <Hero onBook={openModal} />
      <Services />
      <Process />
      <Modernize />
      <Mail />
      <Local />
      <AIStatement />
      <Scenarios />
      <ContactCTA onBook={openModal} />
    </>
  );
}
